import React, { Fragment, useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import CollapseableCard from "../../../CommonElements/Collapse/CollapseableCard";
import { Button, Col } from "reactstrap";
import { ChevronLeft, ChevronRight } from "react-feather";

const RealisasiChart = (props) => {
  const { updatedanggaranbuklist } = props;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    updateData(updatedanggaranbuklist);
  }, [currentSlide, updatedanggaranbuklist]);

  const updateData = (updatedanggaranbuklist) => {
    const initialData = [["Unit Kerja", "Persentase"]];
    const recentData = updatedanggaranbuklist[currentSlide];

    const useData = [
      recentData?.id_unit_kerja,
      parseFloat(
        (
          parseInt(recentData?.total_terpakai) /
          updatedanggaranbuklist[updatedanggaranbuklist.length - 1]
            ?.total_terpakai
        ).toFixed(5)
      ),
    ];

    const fasilkom = [
      "Fasilkom",
      (updatedanggaranbuklist[updatedanggaranbuklist.length - 1]
        ?.total_terpakai -
        parseInt(recentData?.total_terpakai)) /
        updatedanggaranbuklist[updatedanggaranbuklist.length - 1]
          ?.total_terpakai,
    ];

    initialData.push(fasilkom);
    initialData.push(useData);
    setData(initialData);
  };

  const options = {
    tooltip: {
      trigger: "selection",
      format: "#.#####",
    },
    pieSliceText: "label",
    colors: ["#3366CC", "#EF6057"],
    slices: {
      1: { offset: 0.1 },
    },
  };

  const handleNext = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide + 1) % (updatedanggaranbuklist.length - 1)
    );
  };
  const handlePrev = () => {
    setCurrentSlide(
      (prevSlide) =>
        (prevSlide - 1 + (updatedanggaranbuklist.length - 1)) %
        (updatedanggaranbuklist.length - 1)
    );
  };

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={"Persentase Realisasi Unit Kerja/Fakultas"}>
          <p className="text-center w-100">
            {updatedanggaranbuklist[currentSlide]?.id_unit_kerja ||
              "Anggaran tidak ditemukan"}
          </p>
          <Chart
            chartType="PieChart"
            data={data}
            options={options}
            width={"100%"}
            height={"400px"}
          />
          <div className="row position-absolute top-50 start-0 translate-middle-y">
            <Button
              color="link"
              className="rounded-circle"
              onClick={() => handlePrev()}
            >
              <ChevronLeft />
            </Button>
          </div>
          <div className="row position-absolute top-50 end-0 translate-middle-y">
            <Button
              color="link"
              className="rounded-circle"
              onClick={() => handleNext()}
            >
              <ChevronRight />
            </Button>
          </div>
        </CollapseableCard>
      </Col>
    </Fragment>
  );
};

export default RealisasiChart;
